import QuotationRoutesFcl from "./quotation-routes-fcl.component";

export default QuotationRoutesFcl;
